export default __webpack_public_path__ + "static/armed-forces-covenant-405127ba9953cb2739b50e8499f27152.svg";